import React, { useState } from "react";
import { auth, db } from "../../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import './register.css';

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");

  const handleRegister = async () => {
    try {
      // Create a new user with email and password
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Save user email and role to Firestore
      await setDoc(doc(db, "users", user.uid), { 
        email: email, 
        role: role 
      });

      alert("Registration successful!");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  return (
    <div className="mainRegister">
      <div className="main">
      <div className="register">
      <h2>Register</h2>
      <input 
      className="register-input"
        type="email" 
        placeholder="Email" 
        onChange={(e) => setEmail(e.target.value)} 
        value={email}
      /><br/>
      <input 
      className="register-input"
        type="password" 
        placeholder="Password" 
        onChange={(e) => setPassword(e.target.value)} 
        value={password}
      /><br/>
      <select className="register-input" onChange={(e) => setRole(e.target.value)} value={role}>
        <option value="">Select Role</option>
        <option value="admin">Admin</option>
        <option value="user">User</option>
      </select><br/>
      <button className="button" onClick={handleRegister}>Register</button>
    </div>
    </div>
      </div>
      
    
  );
};

export default Register;
